import request from '../util/request'

// 查看问卷答卷列表
export function getAnswers(query) {
  return request({
    url: 'pr/survey-posts',
    method: 'get',
    params: query
  })
}

// 查看问卷答卷详情
export function getAnswerDetail(id) {
  return request({
    url: `pr/survey-posts/${id}`,
    method: 'get'
  })
}

// 查看问卷分析列表
export function getAnalyzes(id) {
  return request({
    url: `pr/survey-posts/analyze/${id}`,
    method: 'get'
  })
}

// 导出问卷的答卷的excel
export function exportAnswer(id) {
  return request({
    url: `pr/survey-posts/export/${id}`,
    method: 'get'
  })
}

// 导出问卷的分析的excel
export function exportAnalyze(id) {
  return request({
    url: `pr/survey-posts/analyze/export/${id}`,
    method: 'get'
  })
}


export function exportMedias(id){
  return request({
    url:'pr/survey-posts/export-media/'+id,
    method: 'get',
    timeout: 60000
  })
}